require('./brokerLegalDocumentationBox.scss');
// @ Vendor
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { v1 as uuidv1 } from 'uuid';
import readIcon from 'assets/icons/leido.svg';

// @ Commons
import { OKButton } from 'commonsComponents/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';
// @ Utils
const { FormattedText, formatText } = require('core/i18n').i18n;
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const { openBase64pdfInNewTab } = require('utilities/pdfDocumentsHelper');
const { recordLinkV2 } = require("../../../utilities/tagging");
const { taggingEventHandled } = require('utilities/taggingEventHandled')

// @ Actions
import { fetchLegalDocuments, fetchAlternativeFundsLegalDocuments } from 'actions/brokerFundLegalDocument';
import {
    getInitFundsDocumentation,
    setLegalDocumentationChecked,
    getInitPlansDocumentation,
    getInitOPADocumentation,
    getInitCapitalIncreaseDocumentation,
    getInitOPVDocumentation,
    getInitExchangeDocumentation,
    getInitWarrantsDocumentation,
    getInitETFDFI
} from 'actions/brokerLegalDocumentation';
import { getOwnProduct } from 'utilities/brokerLegalDocumentation/legalDocumentation'
// @constants
const {
    BROKER_PRODUCT_TYPE_FUNDS,
    BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS,
    BROKER_PRODUCT_TYPE_PLANS,
    BROKER_PRODUCT_TYPE_OPA,
    BROKER_PRODUCT_TYPE_CAPITAL_INCREASE,
    BROKER_PRODUCT_TYPE_OPV,
    BROKER_PRODUCT_TYPE_EXCHANGE,
    BROKER_PRODUCT_TYPE_LEGAL_WARRANTS,
    BROKER_PRODUCT_TYPE_ETFS_ES,
    CONTENT_TYPE_PDF,
} = require('constants/index');

const OPEN_URL = 'OPEN_URL'
const OPEN_PDF = 'OPEN_PDF'
const OPEN_BASE64 = 'OPEN_BASE64'
const OPEN_FROM_BUCKET = 'OPEN_FROM_BUCKET'

class BrokerLegalDocumentationBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            called: false
        }
    }
    componentDidMount() {
        this.setInitialDocumentsByType()
    }

    componentWillReceiveProps(nextProps) {
        const { called } = this.state
        const { immLegalDocumentationProduct } = nextProps
        if (immLegalDocumentationProduct && !called) {
            const completed = immLegalDocumentationProduct.get('completed')
            if (completed) {
                this.setState({ called: true })
                const { reportCompleted } = this.props
                reportCompleted()
            }
        }
    }

    setInitialDocumentsByType = () => {
        const {
          productType,
          isin,
          enableTransactionCost,
          secId,
          originCountry,
          getInitFundsDocumentation,
          fetchLegalDocuments,
          fetchAlternativeFundsLegalDocuments,
          isBuildYourPortfolio,
          history,
          enableEconomicReport,
        } = this.props;
        const isAlternativeFund = productType === BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS
        switch (productType) {
            case BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS:
                fetchAlternativeFundsLegalDocuments(isin, originCountry, () => {
                  getInitFundsDocumentation(
                    uuidv1(),
                    isin,
                    originCountry,
                    enableTransactionCost,
                    isBuildYourPortfolio,
                    enableEconomicReport,
                    isAlternativeFund
                  );
                },
                history
                );
                
            break;
          case BROKER_PRODUCT_TYPE_FUNDS:
            fetchLegalDocuments(
              isin,
              secId,
              () => {
                getInitFundsDocumentation(
                  uuidv1(),
                  isin,
                  originCountry,
                  enableTransactionCost,
                  isBuildYourPortfolio,
                  enableEconomicReport
                );
              },
              enableTransactionCost,
              isBuildYourPortfolio,
              history
            );
            break;
          case BROKER_PRODUCT_TYPE_PLANS:
            const { planDgsCode, isAportation, getInitPlansDocumentation } = this.props;
            getInitPlansDocumentation(uuidv1(), planDgsCode, isAportation);
            break;
          case BROKER_PRODUCT_TYPE_OPA:
            const { getInitOPADocumentation } = this.props;
            getInitOPADocumentation(uuidv1(), isin);
            break;
          case BROKER_PRODUCT_TYPE_CAPITAL_INCREASE:
            const { getInitCapitalIncreaseDocumentation } = this.props;
            getInitCapitalIncreaseDocumentation(uuidv1(), isin);
            break;
          case BROKER_PRODUCT_TYPE_OPV:
            const { getInitOPVDocumentation } = this.props;
            getInitOPVDocumentation(uuidv1(), isin);
            break;
          case BROKER_PRODUCT_TYPE_EXCHANGE:
            const { getInitExchangeDocumentation } = this.props;
            getInitExchangeDocumentation(uuidv1(), isin);
            break;
          case BROKER_PRODUCT_TYPE_LEGAL_WARRANTS:
            const { getInitWarrantsDocumentation, isSell } = this.props;
            getInitWarrantsDocumentation(uuidv1(), isin, isSell, enableTransactionCost);
            break;
          case BROKER_PRODUCT_TYPE_ETFS_ES.toUpperCase():
            const { getInitETFDFI } = this.props;
            getInitETFDFI(uuidv1(), isin);
            break;
          default:
            break;
        }
    }

    handleClick = (documentType, alreadyRead, pdf = null, link, openType) => {
        const {
            history,
            immBrokerLegalDocumentation,
            isin,
            iso,
            productDefinition,
            productType,
            setLegalDocumentationChecked,
            planDgsCode,
        } = this.props;
        const fixedProductType = productType === BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS ? BROKER_PRODUCT_TYPE_FUNDS : productType
        const data = {
            documentType,
            product: getOwnProduct(productType, isin, planDgsCode),
            productDefinition,
            productType: fixedProductType,
            uuid: immBrokerLegalDocumentation.get('uuid'),
            marker: iso,
            link
        }
        const openFromBucket = openType === OPEN_FROM_BUCKET

        if (openType === OPEN_PDF) {
            const {
                dataID,
                base64String
            } = pdf
            downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID)
        } else if (openType === OPEN_BASE64) {
            const {
                base64String
            } = link;
            openBase64pdfInNewTab(base64String)
        }
        return !alreadyRead && setLegalDocumentationChecked(data, history, openFromBucket);
    }

    handleClickButton(documentType, alreadyRead, openType, link) {
        this.props.pageName && taggingEventHandled(this.props.pageName, `buttonLegalDocs_${documentType}`)
        const { tealium } = this.props;
        if (tealium && !this.props.pageName) {
            recordLinkV2({
                etiquetaEvento: formatText(`brokerLegalDocumentationBox-${documentType}`),
                ...tealium,
            });
        }
        this.handleClick(documentType, alreadyRead, openType === OPEN_PDF ? link : null, link, openType);
    }

    renderButton = (link, documentType, openType) => {
        const { immLegalDocumentationProduct } = this.props;
        const alreadyRead = immLegalDocumentationProduct && immLegalDocumentationProduct.getIn(['documents', documentType, 'read'])
        const isFetching = immLegalDocumentationProduct && immLegalDocumentationProduct.getIn(['documents', documentType, 'isFetching'])
        const loadingButton = alreadyRead ? false : (isFetching ? isFetching : false);

        return (
            <div className="broker-documentation-box__button">
                <OKButton
                    modifier="secondary"
                    onClick={() => this.handleClickButton(documentType, alreadyRead, openType, link)}
                    loading={loadingButton}
                >
                    <FormattedText value={`brokerLegalDocumentationBox-${alreadyRead ? 'readButton' : 'noReadButton'}`} />
                </OKButton>
            </div>
        )
    }

    renderDesc = (documentType, isAlternativeFund) => {
        const POkey = isAlternativeFund ? `ALT_${documentType}` : documentType
        return (
            <div className="broker-documentation-box__desc">
                <div className="broker-documentation-box__desc-icon">
                    {this.renderIcon(documentType)}
                </div>
                <div className="broker-documentation-box__desc-name">
                    <FormattedText className="broker-documentation-box__name" value={`brokerLegalDocumentationBox-${POkey}`} />
                </div>
            </div>
        );
    }

    renderLegalDocument = () => {
        const { immLegalDocumentationProduct, productType } = this.props;
        const isAlternativeFund = productType === BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS
        const validDocuments = immLegalDocumentationProduct.toJSON()
        return Object.keys(validDocuments.documents).map((type, key) => {
            let openType, link;
            if (validDocuments.documents[type].url && !validDocuments.documents[type].fromBucket) {
                openType = OPEN_URL;
                link = validDocuments.documents[type].url;
            } else if( validDocuments.documents[type].base64Data) {
                openType = OPEN_BASE64;
                link = validDocuments.documents[type].base64Data;
            } else if(validDocuments.documents[type].fromBucket) {
                openType = OPEN_FROM_BUCKET;
                link = validDocuments.documents[type].url;
            } else {
                openType = OPEN_PDF;
                link = validDocuments.documents[type].pdf;
            }
            return (
                <div key={key} className="broker-documentation-box__documentation">
                    <div className="row">
                        <div className="col-xs-9 col-md-10">
                            { this.renderDesc(type, isAlternativeFund) }
                        </div>
                        <div className="col-xs-3 col-md-2">
                            {this.renderButton(link, type, openType)}
                        </div>
                    </div>
                </div>
            );
        })
    }

    renderIcon = (documentType) => {
        const { immLegalDocumentationProduct } = this.props;
        if (immLegalDocumentationProduct && immLegalDocumentationProduct.getIn(['documents', documentType, 'read'])) {
            return <img className="broker-documentation-box__read-icon" src={readIcon} />
        }
        return <i className="icon-documento broker-documentation-box__icon" />
    }

    render() {
        const {
            immLegalDocumentationProduct,
        } = this.props;
        if (immLegalDocumentationProduct && immLegalDocumentationProduct.size) {
            return this.renderLegalDocument();
        }
        return <LoadingSection />;
    }
}

BrokerLegalDocumentationBox.propTypes = {
    className: PropTypes.string,
    documentType: PropTypes.string.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    fetchAlternativeFundsLegalDocuments: PropTypes.func.isRequired,
    immBrokerLegalDocumentation: PropTypes.object.isRequired,
    immLegalDocumentationProduct: PropTypes.object.isRequired,
    getInitFundsDocumentation: PropTypes.func.isRequired,
    getInitPlansDocumentation: PropTypes.func.isRequired,
    getInitOPADocumentation: PropTypes.func.isRequired,
    getInitCapitalIncreaseDocumentation: PropTypes.func.isRequired,
    getInitOPVDocumentation: PropTypes.func.isRequired,
    getInitExchangeDocumentation: PropTypes.func.isRequired,
    getInitWarrantsDocumentation: PropTypes.func.isRequired,
    getInitETFDFI: PropTypes.func.isRequired,
    isin: PropTypes.string,
    iso: PropTypes.string,
    originCountry: PropTypes.string.isRequired,
    productDefinition: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    secId: PropTypes.string,
    setLegalDocumentationChecked: PropTypes.func.isRequired,
    reportCompleted: PropTypes.func.isRequired,
    isAportation: PropTypes.bool,
    planDgsCode: PropTypes.string,
    isSell: PropTypes.bool,
    enableTransactionCost: PropTypes.bool,
    tealium: PropTypes.object,
    isBuildYourPortfolio: PropTypes.bool,
    enableEconomicReport: PropTypes.bool,
    pageName: PropTypes.string,
    history: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
};

BrokerLegalDocumentationBox.defaultProps = {
    enableTransactionCost: true,
    isBuildYourPortfolio: false,
    pageName: '',
    enableEconomicReport: true,
}

export default withRouter(connect(
    (state, ownProps) => ({
        immBrokerLegalDocumentation: state.brokerLegalDocumentation,
        immLegalDocumentationProduct: state.brokerLegalDocumentation.getIn(['boxes', getOwnProduct(ownProps.productType, ownProps.isin, ownProps.planDgsCode)]),
        originCountry: state.profile.get('originCountry'),
        immFeatureFlags: state.flagBasedFeatures,
    }),
    {
        fetchLegalDocuments,
        fetchAlternativeFundsLegalDocuments,
        getInitFundsDocumentation,
        getInitPlansDocumentation,
        getInitOPADocumentation,
        getInitCapitalIncreaseDocumentation,
        getInitOPVDocumentation,
        getInitExchangeDocumentation,
        getInitWarrantsDocumentation,
        setLegalDocumentationChecked,
        getInitETFDFI
    }
)(BrokerLegalDocumentationBox));
